import "@/framework/appmain_cli3";
